import React, { useCallback, useMemo } from 'react';

import Checkbox from '@repo/editor/src/components/Checkbox/Checkbox';
import { themeStyle } from '@repo/ui/theming';

import { JsonFieldType } from '../schema';
import { CheckboxLabel, CheckboxWrapper } from '../styles';
import { fieldTypeMatchesValue } from '../utils';

import { AiTextToolCheckboxProps } from './types';

const checkboxCustomStyles = {
  borderColor: themeStyle.varBlueMedium,
  size: '16px',
};

const AiTextToolCheckbox: React.FC<AiTextToolCheckboxProps> = ({
  value: currentValue,
  field,
  onChange,
  disabled,
}) => {
  const { key, type, label } = field;
  const value = useMemo(
    () => (fieldTypeMatchesValue(type, currentValue) ? currentValue : false),
    [type, currentValue]
  );

  const handleInputChange = useCallback(() => {
    onChange<JsonFieldType.Checkbox>(key, !currentValue);
  }, [onChange, key, currentValue]);

  return (
    <CheckboxWrapper key={key} disabled={disabled}>
      <Checkbox
        theme={checkboxCustomStyles}
        value={value}
        onClick={handleInputChange}
      />
      <CheckboxLabel onClick={() => handleInputChange()}>{label}</CheckboxLabel>
    </CheckboxWrapper>
  );
};

export default AiTextToolCheckbox;
